import React, { useEffect, useState } from 'react';

import AboutHero from './components/AboutHero/AboutHero';

import './About.css';
import AboutContent from './components/AboutContent/AboutContent';

function About() {
  const featureList1 = [
    {
      img: `${process.env.PUBLIC_URL}/trump.jpg`,
      alt: '전문가 검수',
      title: '전문가 검수 시스템',
      description: '검증된 전문가들이 직접 기타의 상태를 꼼꼼히 검수합니다.',
    },
    {
      img: `${process.env.PUBLIC_URL}/box.jpg`,
      alt: '온라인 거래',
      title: '편리한 온라인 거래',
      description: '시간과 장소에 구애받지 않는 안전한 거래 방식을 제공합니다.',
    },
    {
      img: `${process.env.PUBLIC_URL}/handshake.jpg`,
      alt: '신뢰성',
      title: '신뢰할 수 있는 중개',
      description: '제3자 중개 시스템으로 안전하고 투명한 거래를 보장합니다.',
    },
  ];

  const featureList2 = [
    {
      img: `${process.env.PUBLIC_URL}/trump.jpg`,
      alt: '판매 등록',
      title: '판매 등록',
      description: '판매하실 기타의 정보와 사진을 등록합니다',
    },
    {
      img: `${process.env.PUBLIC_URL}/box.jpg`,
      alt: '전문가 검수',
      title: '전문가 검수',
      description: '13가지의 과정을 거쳐 기타의 상태를 검증합니다.',
    },
    {
      img: `${process.env.PUBLIC_URL}/handshake.jpg`,
      alt: '안전 거래',
      title: '안전 거래',
      description: '검수가 완료된 기타를 안전하게 배송받습니다.',
    },
  ];

  let [isHVisible, setIsHVisible] = useState(false);
  let [isP1Visible, setIsP1Visible] = useState(false);
  let [isP2Visible, setIsP2Visible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsHVisible(true), 200);
    setTimeout(() => setIsP1Visible(true), 600);
    setTimeout(() => setIsP2Visible(true), 1000);
  }, [])

  return (
    <div className="about-container common-padding">
      <AboutHero isHVisible={isHVisible} isP1Visible={isP1Visible} isP2Visible={isP2Visible} />

      <AboutContent
        title={"우리는 기타리스트들의 안전한 거래를 지원합니다"}
        description={`Pick & Sell은 기타리스트들을 위한 전문 중고거래 플랫폼입니다. \n 전문가의 검수를 통해 신뢰성 있는 거래 경험을 제공합니다.`}
        features={featureList1}
      />

      <AboutContent
        title={"거래 프로세스"}
        description={`Pick & Sell은 단순한 중고거래를 넘어, 신뢰를 배송합니다.\n전문가 검수를 거친 진짜 거래, 안심하고 경험하세요.`}
        features={featureList2}
      />

      <section className="about-contact">
        <h2>문의하기</h2>
        <p>더 자세한 내용이 궁금하시다면 언제든 문의해주세요.</p>
        <div className="contact-info">
          <p>Email: itasuk@naver.com</p>
          <p>Tel: 1544-0000</p>
        </div>
      </section>
    </div>
  );
}

export default About;
